import { render } from "./Onboard.vue?vue&type=template&id=3a7de224"
import script from "./Onboard.vue?vue&type=script&lang=js"
export * from "./Onboard.vue?vue&type=script&lang=js"

import "./Onboard.vue?vue&type=style&index=0&id=3a7de224&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__